import { ConsentDataResponse, ConsentDetailResponse } from '../../api/response/ConsentResponse';
import { ConsentDataResponseV2 } from '../../api/response/ConsentResponseV2';
import { CompanyClient } from '../../api/CompanyClient';
import { useEffect, useState } from 'react';
import { ConsentTrueRequest } from '@api/request/ConsentRequest';
import { TokenHelper } from '@ptvn-react/authentication';
import { useLocation } from 'react-router-dom';

const usePDPA = () => {

    const initialConsentDetail: ConsentDetailResponse = {
        id: '',
        name: 'string',
        descriptionEn: 'Loading...',
        descriptionTh: 'Loading...',
        revision: 0,
        status: 'string'
    }

    const initialConsentData: ConsentDataResponse = {
        id: '',
        application: '',
        descriptionEn: '',
        descriptionTh: '',
        lifespan: 0,
        name: '',
        privacyNoticeRef: '',
        purposes: [],
        ref1: '',
        ref2: '',
        ref3: '',
        revision: 0,
        status: '',
    }

    const initialConsentDataV2: ConsentDataResponseV2 = {
        application: '',
        descriptionEn: '',
        descriptionTh: '',
        revision: 0,
        lastUpdated: 0,
        isNewVersion: false
    }
    
    const location = useLocation();
    const [acceptConsentSC, setAcceptConsentSC] = useState<boolean>(() => {
        const stored = localStorage.getItem('isAcceptedConsentSC');
        if (!['/home', '/portal','/company-register'].includes(location.pathname)) {
            return true
        } else if (stored) {
            return JSON.parse(stored)
        } else {
            return false
        }
    });
    const [termsAndCondition, setTermsAndCondition] = useState<ConsentDataResponse>(initialConsentData);
    const [privacyNotice, setPrivacyNotice] = useState<ConsentDetailResponse>(initialConsentDetail);

    const [consentDataV2, setConsentDataV2] = useState<ConsentDataResponseV2[]>([]);
    const [termsAndConditionV2, setTermsAndConditionV2] = useState<ConsentDataResponseV2>(initialConsentDataV2);
    const [privacyNoticeV2, setPrivacyNoticeV2] = useState<ConsentDataResponseV2>(initialConsentDataV2);

    const [acceptPDPACP, setAcceptPDPACP] = useState<boolean>(false);
    const [pdpaContentCP, setPDPAContentCP] = useState<ConsentDataResponse>(initialConsentData);

    const [requestCallTrueCOC, setRequestCallTrueCOC] = useState<ConsentTrueRequest>();
    const [loading, setLoading] = useState<boolean>(false);
    const [acceptPDPATrue, setAcceptPDPATrue] = useState<boolean>(false);
    const [pdpaContentTrue, setPDPAContentTrue] = useState<ConsentDataResponse>(initialConsentData);

    const [convertFormat, setConvertFormat] = useState<boolean>(false);

    const prefix18DivColor = '<h3 class="title-border">';
    const prefix16DivColor = '<div style=\"color:#01365B;font-size:14px;font-weight: bold;\">';
    const postfixDivColor = '</div>';
    const postFixH = '</h3>';
    const prefixBackgroundColor = '<div style="padding: 0.25rem; margin-bottom: 0.5rem; border-radius: 0.25rem; border: 1px solid #4b98cd; background-color: #d4ecfe;">'

    useEffect(() => {
        let token = TokenHelper.getToken()
        if (token) {
            // getConsent();
            // เปลี่ยน getConsent(); ให้มา call getConsentV2();
            getConsentV2();
            getCOC();
        } else {
            setAcceptConsentSC(true);
        }
    }, []);

    useEffect(() => {
        if (requestCallTrueCOC?.username) {
            getCOCTrue();
        }
    }, [requestCallTrueCOC]);

    const getConsent = () => {
        CompanyClient.getRequestConsent().subscribe(res => {
            if (res.data.id != null) {
                setTermsAndCondition(res.data.data);
                setPrivacyNotice(res.data.privacyNotice);
                if (res.data.data != null) {
                    transformContent(res.data.data, res.data.privacyNotice)
                }
            } else {
                setAcceptConsentSC(false);
            }
        }, error => {
            setAcceptConsentSC(true);
        });
    }

    const getConsentV2 = () => {
        CompanyClient.getRequestConsentV2().subscribe(res => {
            if (res.data?.length > 0) {
                setConsentDataV2(res.data);
                let transformContentCount = 0
                res.data.forEach((item) => {
                    if(item.application === 'TERM-AND-CONDITION') {
                        setTermsAndConditionV2(item)
                        transformContentV2(item)
                        transformContentCount += 1
                    } else if (item.application === 'PRIVACY-POLICY') {
                        setPrivacyNoticeV2(item)
                        transformContentV2(item)
                        transformContentCount += 1
                    }
                    
                    if (res.data?.length === transformContentCount) {
                        setConvertFormat(true);
                    }
                });
            } else {
                setAcceptConsentSC(true);
                localStorage.setItem('isAcceptedConsentSC', JSON.stringify(true));
            }
        }, error => {
            setAcceptConsentSC(true);
        });
    }

    const getCOC = () => {
        // get COC CP
        CompanyClient.getCOC('CP').subscribe(res => {
            if (res?.data?.id != null) {
                let coc = res.data.data;
                coc.descriptionEn = res?.data?.privacyNotice?.descriptionEn;
                coc.descriptionTh = res?.data?.privacyNotice?.descriptionTh;
                setPDPAContentCP(coc);
            } else {
                setAcceptPDPACP(true);
            }
        }, error => {
            setAcceptPDPACP(true);
        });
    }

    const getCOCTrue = () => {
        setLoading(true);
        // should validate role before get COC True
        const username = requestCallTrueCOC?.username ? requestCallTrueCOC.username : '';
        CompanyClient.getCOC('True', username).subscribe(res => {
            if (res && res.data && res.data.id != null) {
                let coc = res.data.data;
                coc.descriptionEn = res?.data?.privacyNotice?.descriptionEn;
                coc.descriptionTh = res?.data?.privacyNotice?.descriptionTh;
                setPDPAContentTrue(coc);
            } else {
                setAcceptPDPATrue(true)
            }
        }, error => {
            setAcceptPDPATrue(true);
        }).add(() => { setLoading(false); });
    }

    const transformContent = (termsAndCondition: ConsentDataResponse, privacyNotice: ConsentDetailResponse) => {
        let termEN = termsAndCondition.descriptionEn;
        let termTH = termsAndCondition.descriptionTh;

        termEN = termEN.split('thisisadiv16start').join(prefix16DivColor);
        termEN = termEN.split('thisisadiv18start').join(prefix18DivColor);
        termEN = termEN.split('thisisadivend').join(postfixDivColor);
        termEN = termEN.split('thisisadiv18end').join(postFixH);

        termTH = termTH.split('thisisadiv16start').join(prefix16DivColor);
        termTH = termTH.split('thisisadiv18start').join(prefix18DivColor);
        termTH = termTH.split('thisisadivend').join(postfixDivColor);
        termTH = termTH.split('thisisadiv18end').join(postFixH);

        let termAndCon = termsAndCondition;
        termAndCon.descriptionEn = termEN;
        termAndCon.descriptionTh = termTH;
        setTermsAndCondition(termAndCon);

        let privacyEN = privacyNotice.descriptionEn;
        let privacyTH = privacyNotice.descriptionTh;

        privacyEN = privacyEN.split('thisisadiv16start').join(prefix16DivColor);
        privacyEN = privacyEN.split('thisisadiv18start').join(prefix18DivColor);
        privacyEN = privacyEN.split('thisisadivend').join(postfixDivColor);
        privacyEN = privacyEN.split('thisisadiv18end').join(postFixH);

        privacyTH = privacyTH.split('thisisadiv16start').join(prefix16DivColor);
        privacyTH = privacyTH.split('thisisadiv18start').join(prefix18DivColor);
        privacyTH = privacyTH.split('thisisadivend').join(postfixDivColor);
        privacyTH = privacyTH.split('thisisadiv18end').join(postFixH);

        let privacy = privacyNotice;
        privacy.descriptionEn = privacyEN;
        privacy.descriptionTh = privacyTH;
        setPrivacyNotice(privacy);
        setConvertFormat(true);
    }

    const transformContentV2 = (consentData: ConsentDataResponseV2) => {
        let consentEN = consentData.descriptionEn;
        let consentTH = consentData.descriptionTh;

        consentEN = consentEN.split('thisisadivbg').join(prefixBackgroundColor);
        consentEN = consentEN.split('thisisadiv16start').join(prefix16DivColor);
        consentEN = consentEN.split('thisisadiv18start').join(prefix18DivColor);
        consentEN = consentEN.split('thisisadivend').join(postfixDivColor);
        consentEN = consentEN.split('thisisadiv18end').join(postFixH);

        consentTH = consentTH.split('thisisadivbg').join(prefixBackgroundColor);
        consentTH = consentTH.split('thisisadiv16start').join(prefix16DivColor);
        consentTH = consentTH.split('thisisadiv18start').join(prefix18DivColor);
        consentTH = consentTH.split('thisisadivend').join(postfixDivColor);
        consentTH = consentTH.split('thisisadiv18end').join(postFixH);

        let transformContentData = consentData;
        transformContentData.descriptionEn = consentEN;
        transformContentData.descriptionTh = consentTH;

        if(consentData.application === 'TERM-AND-CONDITION') {
            setTermsAndConditionV2(transformContentData);
        } else if (consentData.application === 'PRIVACY-POLICY') {
            setPrivacyNoticeV2(transformContentData);
        }
    }

    const onAcceptConsent = () => {

        // เปลี่ยน acceptConsent มาเป็น acceptConsentV2
        // CompanyClient.acceptConsent(termsAndCondition.id).subscribe((responsePost) => {
        //     setAcceptConsentSC(true);
        // }, (error) => {
        //     setAcceptPDPATrue(false);
        // });
        
        const application: string[] = consentDataV2.map(item => item.application);
        CompanyClient.acceptConsentV2(application).subscribe((responsePost) => {
            setAcceptConsentSC(true);
            localStorage.setItem('isAcceptedConsentSC', JSON.stringify(true));
        }, (error) => {
            setAcceptPDPATrue(false);
        });
    }

    const onCancelConsent = () => {
        setAcceptConsentSC(true);
        localStorage.setItem('isAcceptedConsentSC', JSON.stringify(true));
    }

    const onAcceptPDPACP = () => {
        CompanyClient.acceptCOC('CP', pdpaContentCP.id).subscribe((responsePost) => {
            setAcceptPDPACP(true);
        }, (error) => {
            setAcceptPDPATrue(false);
        });
    }

    const onAcceptPDPATrue = () => {
        const username = requestCallTrueCOC?.username ? requestCallTrueCOC.username : '';
        CompanyClient.acceptCOC('True', pdpaContentTrue.id, username).subscribe((responsePost) => {
            setAcceptPDPATrue(true);
        }, (error) => {
            setAcceptPDPATrue(false);
        });
    }

    return {
        consentDataV2,
        termsAndCondition,
        termsAndConditionV2,
        privacyNotice,
        privacyNoticeV2,
        acceptConsentSC,
        onAcceptConsent,
        onCancelConsent,

        pdpaContentCP,
        acceptPDPACP,
        onAcceptPDPACP,

        setRequestCallTrueCOC,
        pdpaContentTrue,
        acceptPDPATrue,
        onAcceptPDPATrue,

        loading,
        convertFormat
    };

};

export default usePDPA;